/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import VisibilitySensor from 'react-visibility-sensor';

import { IAquaglideVisibilityContainerViewProps } from './aquaglide-visibility-container';

export const AquaglideVisibilityContainerView: React.FC<IAquaglideVisibilityContainerViewProps> = props => {
    const { visibilityCategories, visibilityClassName } = props;

    return (
        <VisibilitySensor partialVisibility>
            {({ isVisible }) => (
                <div className={visibilityClassName}>
                    <div className={isVisible ? 'sticky-header' : 'notsticky-header'}>{visibilityCategories}</div>
                </div>
            )}
        </VisibilitySensor>
    );
};

export default AquaglideVisibilityContainerView;
